var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"title-credit-name",on:{"click":function($event){$event.preventDefault();return _setup.clicked({ searchString: _vm.name, personId: _vm.id })}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }